import React from 'react';
import BlockedAccount from '../components/blocked_account';

const App = ({ email }) => {
  return (<BlockedAccount email={ email } />);
};

export default App;
